var _path, _path2, _path3, _path4, _g, _circle, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M5.333 42.64h53.334v16H5.333v-16z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M53.333 10.64H48v21.333h-5.333l8 8 8-8h-5.334V10.64z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    d: "M31.999 38.64c0-6.628-5.373-12-12-12s-12 5.372-12 12c0 3.77 1.738 7.133 4.457 9.333h15.086A11.977 11.977 0 0032 38.64zm-16.8 0l4.8 4.8 4.8-4.8-4.8-4.8-4.8 4.8z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    height: 22,
    width: 25,
    y: 26,
    x: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    id: "a"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M7.999 26.64h24v21.333h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F0B90B",
    transform: "rotate(90 20 38.64)",
    r: 12,
    cy: 38.64,
    cx: 19.999
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.009 31.167a10.962 10.962 0 00-2.967 7.515c0 2.768 1.022 5.296 2.71 7.23l.71-.711a9.96 9.96 0 01-2.39-6.49 9.965 9.965 0 012.674-6.807l-.737-.737zm14.87 14.87a9.965 9.965 0 01-6.808 2.675 9.964 9.964 0 01-6.739-2.612l-.706.706a10.96 10.96 0 007.416 2.876c2.906 0 5.548-1.127 7.515-2.967l-.678-.678zm1.542-.227l-.68-.68a9.96 9.96 0 002.33-6.418 9.966 9.966 0 00-2.611-6.74l.706-.706a10.96 10.96 0 012.876 7.416c0 2.72-.987 5.208-2.621 7.128zM13.653 31.042l-.739-.739a10.957 10.957 0 017.128-2.62c2.767 0 5.296 1.021 7.23 2.709l-.712.71a9.96 9.96 0 00-6.489-2.39 9.96 9.96 0 00-6.418 2.33z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M19.987 31.645v5.144l-4.272 1.94 4.272-7.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M19.987 36.789v4.468l-4.272-2.528 4.272-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M19.987 42.145v3.471l-4.272-5.999 4.272 2.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#312706",
    d: "M19.987 31.645v5.144l4.272 1.94-4.272-7.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#130F03",
    d: "M19.987 36.789v4.468l4.272-2.528-4.272-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#312807",
    d: "M19.987 42.145v3.471l4.272-5.999-4.272 2.528z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#F0B90B",
    transform: "rotate(90 34.667 18.64)",
    r: 8,
    cy: 18.64,
    cx: 34.667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.34 13.659a7.308 7.308 0 00-1.978 5.01c0 1.845.681 3.53 1.806 4.82l.474-.475a6.64 6.64 0 01-1.594-4.326c0-1.753.677-3.348 1.783-4.538l-.491-.491zm9.913 9.913a6.644 6.644 0 01-4.538 1.783c-1.73 0-3.308-.66-4.493-1.741l-.47.47a7.306 7.306 0 004.943 1.918 7.308 7.308 0 005.01-1.978l-.452-.452zm1.028-.152l-.453-.453a6.64 6.64 0 001.554-4.279 6.64 6.64 0 00-1.742-4.492l.471-.471a7.306 7.306 0 011.918 4.944 7.304 7.304 0 01-1.748 4.751zm-9.845-9.844l-.492-.493a7.305 7.305 0 014.751-1.748 7.31 7.31 0 014.82 1.806l-.474.475a6.64 6.64 0 00-4.326-1.594 6.64 6.64 0 00-4.279 1.554z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M34.659 13.977v3.43L31.81 18.7l2.848-4.723z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M34.659 17.407v2.978L31.81 18.7l2.848-1.293z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M34.659 20.977v2.314l-2.848-3.999 2.848 1.685z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#312706",
    d: "M34.659 13.977v3.43l2.848 1.293-2.848-4.723z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#130F03",
    d: "M34.659 17.407v2.978l2.848-1.685-2.848-1.293z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#312807",
    d: "M34.659 20.977v2.314l2.848-3.999-2.848 1.685z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps2);
export default __webpack_public_path__ + "static/media/steps_2.363be5fbd9a0e13042d779b306af627e.svg";
export { ForwardRef as ReactComponent };